var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ex_tb" },
    [
      _c(
        "wallet-table",
        {
          staticClass: "trade-history-table",
          attrs: {
            headList: _vm.headList,
            contentList: _vm.showList,
            clickCell: _vm.clickCell
          }
        },
        [
          _vm._l(_vm.showList, function(v, i) {
            return _c(
              "span",
              {
                key: i,
                class: {
                  buy: v.rawData.side === 0,
                  sell: v.rawData.side === 1
                },
                attrs: { slot: i + "sideKeyBefore" },
                slot: i + "sideKeyBefore"
              },
              [_vm._v(_vm._s(_vm.$t("tradeOrderHistory.side")[v.rawData.side]))]
            )
          }),
          _vm._v(" "),
          _vm.isShowPage
            ? _c("pagination", {
                staticClass: "__tb_pagination",
                attrs: {
                  slot: "tableBottom",
                  currentPage: _vm.currentPage,
                  toPage: _vm.toPage,
                  totalPage: _vm.totalPage
                },
                slot: "tableBottom"
              })
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c("confirm", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.detailConfirm,
            expression: "detailConfirm"
          }
        ],
        attrs: {
          list: _vm.detailList,
          close: _vm.close,
          title: _vm.$t("tradeOrderHistory.confirmTable.title"),
          heads: _vm.$t("tradeOrderHistory.confirmTable.heads")
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }